<div class="c-content c-content--wrapper u-no-p" [ngStyle]="vm.loading && {'min-height': '300px'}">
	<div *ngIf="!vm.loading">
		<div *ngIf="vm.invoices?.length">
			<div class="c-content c-content--border-bottom u-no-pt u-no-ph@md-and-up u-hidden@up-to-md">
				<div class="o-grid o-grid--wrap">
					<div class="o-grid__cell o-grid__cell--w-30 u-no-p">
						<p class="c-text c-text--gray" aria-hidden="true">{{ 'Invoices.Number' | translate }}</p>
					</div>
					<div class="o-grid__cell o-grid__cell--w-30 u-no-p">
						<p class="c-text c-text--gray" aria-hidden="true">{{ 'Invoices.Type' | translate }}</p>
					</div>
					<div class="o-grid__cell o-grid__cell--w-25 u-no-p">
						<p class="c-text c-text--gray" aria-hidden="true">{{ 'Invoices.Date' | translate }}</p>
					</div>
					<div class="o-grid__cell o-grid__cell--w-15 u-no-p" aria-hidden="true"></div>
				</div>
			</div>
			<ul class="c-list">
				<li *ngFor="let invoice of vm.invoices | startFrom:vm.currentPage*vm.pageSize | arrayLimitTo:vm.pageSize ; let $index=index">
					<div class="c-content c-content--border-bottom u-no-ph@md-and-up">
						<div class="o-grid o-grid--wrap">
							<div class="o-grid__cell o-grid__cell--w-35 o-grid__cell--w-30@md-and-up o-grid__cell--o2@md-and-up u-no-p o-grid__cell--center-v">
								<span class="u-sr-only">{{ 'Invoices.Type' | translate }}:</span>
								<p id="invoiceType_{{$index}}" class="c-text c-text--sm@up-to-md">{{ 'Invoices.Types.' + invoice.type | translate }}</p>
							</div>
							<div class="o-grid__cell o-grid__cell--w-65 o-grid__cell--w-25@md-and-up o-grid__cell--o3@md-and-up u-no-p o-grid__cell--center-v">
								<span class="u-sr-only">{{ 'Invoices.Date' | translate }}:</span>
								<p id="invoiceIssuedDate_{{$index}}" class="c-text c-text--sm@up-to-md c-text--right@up-to-md">{{ invoice.issuedDate | date:'dd.MM.yyyy' }}</p>
							</div>
							<div class="o-grid__cell o-grid__cell--w-67 o-grid__cell--w-30@md-and-up u-no-p o-grid__cell--o1@md-and-up o-grid__cell--center-v u-ost-md@up-to-md">
								<span class="u-sr-only">{{ 'Invoices.Number' | translate }}:</span>
								<p id="invoiceNumber_{{$index}}" class="c-text c-text--bold@up-to-md"><span class="u-hidden@up-to-md">{{ 'Invoices.No' | translate }}: </span>{{ invoice.invoiceNumber }}</p>
							</div>
							<div class="o-grid__cell o-grid__cell--w-fixed o-grid__cell--right u-no-p o-grid__cell--o4@md-and-up o-grid__cell--center-v u-ost-md@up-to-md">
								<a id="invoiceDownloadLink_{{$index}}" href="javascript:void(0)" class="c-text c-text--uppercase c-text--bold" (click)="vm.downloadInvoice(invoice.id)">{{'Common.Download' | translate}}</a>
							</div>
						</div>
					</div>
				</li>
			</ul>
		</div>
		<item-no-content *ngIf="!vm.invoices?.length"></item-no-content>
	</div>
	<loader-overlay *ngIf="vm.loading"></loader-overlay>
</div>
